import { FirebasePopupProvider } from 'constants/auth';

// Which OAuth provider was just linked. The server re-reads the account's providers from Firebase
// and only trusts this as a hint for which one to mark as the latest.
export interface PostRequestPayload {
  provider: FirebasePopupProvider;
}

export interface PostResponsePayload {
  success: boolean;
}

export const LINK_PROVIDER_API_ROUTE = '/v1/users/link-provider';
